import { z } from 'zod';

const baseCheckInResponseSchema = z.object({
  planId: z.guid(),
  promptKey: z.string(),
  promptText: z.string(),
  response: z.string().min(1),
});

export const checkInResponseCreateSchema = baseCheckInResponseSchema;
